module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip"
    }],
    staticClass: "dropdown-new btn btn-default js-pipeline-dropdown-manual-actions",
    attrs: {
      "type": "button",
      "title": "Manual job",
      "data-toggle": "dropdown",
      "data-placement": "top",
      "aria-label": "Manual job",
      "disabled": _vm.isLoading
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.playIconSvg)
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('loading-icon') : _vm._e()], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-align-right"
  }, _vm._l((_vm.actions), function(action) {
    return _c('li', [_c('button', {
      staticClass: "js-pipeline-action-link no-btn btn",
      class: {
        disabled: _vm.isActionDisabled(action)
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isActionDisabled(action)
      },
      on: {
        "click": function($event) {
          _vm.onClickAction(action.path)
        }
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.playIconSvg)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.name))])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/template-compiler?{"id":"data-v-d246eb2a"}!/var/cache/omnibus/src/gitlab-rails/~/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d246eb2a"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./pipelines/components/pipelines_actions.vue
// module chunks = commit_pipelines pipelines